import jwt_decode from "jwt-decode";

const decoder = (token) => {
  return {
    data: jwt_decode(token),
    token: token,
  };
};
export default decoder;
